<script>
  import {
    DataTable,
    ToolbarSearch,
    ToolbarContent,
    Link,
  } from "carbon-components-svelte";
  import { config } from "./configs/textbooks-spring-2024.js";
  import { onMount } from "svelte";
  import Papa from "papaparse";
  import { search } from "./lib/search.js";
  let fullData = [];
  let subData = [];
  let data = [];
  let error = {};

  let searchTerm = "";

  onMount(async () => {
    Papa.parse(config.url, {
      download: true,
      header: true,
      complete: function (results) {
        data = results.data;
        if (config.prefilterData) {
          fullData = config.prefilterData(data);
          console.log(fullData);
          subData = fullData[[config.subDataKey]]
          console.log(subData);
          data = fullData[[config.dataKey]];
        }
        data.map((entry, index) => {
          entry.id = index;
        });
        console.log(data)
      },
      error: function (err) {
        error = err;
        console.log(err);
      },
    });
  });
</script>

<main>
  {#if data.length === 0}
    <div class="loading">
      <p>...Loading Data</p>
    </div>
  {:else}
    <!-- svelte-ignore missing-declaration -->
    <DataTable
      sortable
      hover={false}
      expandable={config.expandable}
      title={config.title != "" && config.title}
      description={config.description != "" && config.description}
      rows={search(searchTerm, data, config.searchFields)}
      headers={config.headers}
    >
      <ToolbarContent>
        <ToolbarSearch persistent bind:value={searchTerm} />
      </ToolbarContent>
      <svelte:fragment slot="cell" let:row let:cell>
        {#if cell.key === config.link?.field && config.link?.url}
          <Link href={row[config.link.url]} target="_blank">{cell.value}</Link>
        {:else}
          {cell.value}
        {/if}
      </svelte:fragment>
      
      <svelte:fragment slot="expanded-row" let:row>
        {#if config.prefilterData}
        <!-- <pre> -->
            {#key subData}
                <DataTable
                sortable
                size="medium"
                zebra
                headers={config.subHeaders}
                rows={subData.filter((entry) => {return Object.keys(entry)[0] === row.key})[0][[row.key]].map((option, index) => {option.id = index; return option})}>
                <span slot="cell" let:row let:cell>{cell.value}</span>
                </DataTable>
                {/key}
        <!-- </pre> -->
        {/if}
        </svelte:fragment>
    </DataTable>
  {/if}
</main>
<div data-iframe-height="" />

<style>
</style>
